export default "__VITE_ASSET__DHHoqqdO__"